export function debounce(fn, delay = 1000) {
  let timeoutId = null

  return (...args) => {
    clearTimeout(timeoutId)
    timeoutId = setTimeout(() => fn.apply(this, args), delay)
  }
}

export function transformToHourFormat(totalSeconds, { shortFormat = false }) {
  const hours = formatTimeBlock(Math.floor(totalSeconds / 3600));
  const minutes = formatTimeBlock(
    Math.floor((totalSeconds % 3600) / 60),
  );
  const seconds = formatTimeBlock(totalSeconds % 60);
  if (shortFormat) {
    return `${minutes} : ${seconds}`;
  }

  return `${hours} : ${minutes} : ${seconds}`;
}

function formatTimeBlock(duration) {
  return String(duration).padStart(2, "0");
}

export function formatAudioTime(seconds, totalDuration) {
  if (!seconds || !isFinite(seconds)) seconds = 0;

  const h = Math.floor(seconds / 3600);
  const m = Math.floor((seconds % 3600) / 60);
  const s = Math.floor(seconds % 60);

  if (totalDuration >= 3600) return `${h}:${formatTimeBlock(m)}:${formatTimeBlock(s)}`;
  if (totalDuration >= 600) return `${formatTimeBlock(m)}:${formatTimeBlock(s)}`;
  return `${formatTimeBlock(m)}:${formatTimeBlock(s)}`;
}
